import React from 'react';
import { NavigationTabLink } from 'modules/ui';

export default function ProducerProfileTabs() {
  return (
    <>
      <NavigationTabLink end to="/profile/edit">
        Profile Details
      </NavigationTabLink>
      <NavigationTabLink end to="/profile/edit/social-media-links">
        Social Media Links
      </NavigationTabLink>
    </>
  );
}
